import { render, staticRenderFns } from "./GOptionalRadio.vue?vue&type=template&id=54adf34e&"
import script from "./GOptionalRadio.vue?vue&type=script&lang=ts&"
export * from "./GOptionalRadio.vue?vue&type=script&lang=ts&"
import style0 from "./GOptionalRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports